export const MINUTES_SECTIONS = [
  { key: "date", label: "Date", type: "date" },
  { key: "venue", label: "Venue" },
  { key: "time", label: "Time", type: "time" },
  { key: "moderator", label: "Moderator (Scribe)" },
  { key: "opening_prayer", label: "Opening Prayer" },
  { key: "scroll_recitation", label: "Recitation of Scroll" },
  { key: "adoption_by", label: "Adoption of Last Minute", hint: "Who adopted the last minutes" },
  { key: "fc_welcome", label: "FC Welcome Remarks", type: "long" },
  { key: "frigate_update", label: "Frigate Update", type: "long" },
  { key: "aob", label: "AOB (Any Other Business)", type: "long" },
  { key: "adjourned_by", label: "Adjournment of MIT", hint: "Moved by" },
  { key: "seconded_by", label: "Seconded By" },
  { key: "closing_prayer", label: "Closing Prayer" },
  { key: "signed_by", label: "Signed By", hint: "Typed name" },
  { key: "signature_name", label: "Signature", hint: "Typed name — the date it was signed is recorded" },
];

export const EMPTY_MINUTES = Object.fromEntries([...MINUTES_SECTIONS.map((s) => [s.key, ""]), ["adoption_prev_id", ""]]);
